<script setup>
    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    })
    
</script>

<template>
    <div class="blank" :style="{ height: props.data.height + 'px', backgroundColor: props.data.background_color }"></div>
</template>

<style lang="scss" scoped>

</style>